<script>    
    import TeacherRegistrationRequestsComponent from "./TeacherRegistrationRequestsComponent.svelte";
    import NavBarReusable from "./NavbarReusable.svelte";
</script>

<NavBarReusable label="Teacher - Class Registration Requests" />

<div class="classcontainer">
    <h3>Class Registration Requests</h3>
    <p class="description">
        Review and accept class registration requests from students. Accepted requests will remain visible until handled by administrators.
    </p>
    <TeacherRegistrationRequestsComponent />
</div>

<style>
    .classcontainer {
        padding: 15px;
        background-color: white;
        display: flex;
        flex-direction: column;
        margin-bottom: 15px;
        gap: 10px;
        box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
        border-radius: 8px;
        flex: none;
        color: black;
        align-items: flex-start;
    }

    .classcontainer h3 {
        margin: 0 0 15px 0;
        color: #333;
        font-size: 1.5rem;
    }

    .description {
        color: #666;
        font-size: 0.95rem;
        margin: 0 0 20px 0;
        line-height: 1.4;
    }
</style>
